import Link from 'next/link';
import { getFooterElements } from '../constants';

const CompactFooter = () => (
  <div className="border-t border-[#E2E2E2] p-8 text-sm text-gray-700">
    <div className="reebelo-container flex flex-wrap items-center justify-center gap-5">
      {getFooterElements()
        .terms.links.slice(0, 4)
        .map((el) => (
          <Link
            href={el.link}
            key={el.link}
            className="text-gray-700/60 underline transition-colors duration-150 ease-in-out hover:text-gray-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            {el.title}
          </Link>
        ))}
    </div>
  </div>
);

export default CompactFooter;
